// extracted by mini-css-extract-plugin
module.exports = {"container":"TaskCompletionList_container__3z7tu"};